import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import IconButton from 'LuxKit/Button/IconButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import Group from 'components/utils/Group'

const Root = styled.div`
  display: grid;
  grid-template-columns: ${rem(100)} 1fr;
  gap: ${rem(16)};
  padding: ${rem(12)};
  border-radius: ${rem(20)};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  position: relative;
  &.map-card {
    width: ${rem(375)};
    max-width: 100%;
    display: block;
    padding: 0;
    overflow: hidden;
  }
`
const Image = styled(LoadingBox)`
  height: ${rem(100)};
  .map-card & { height: ${rem(180)}; }
`
const Content = styled(Group)`
  .map-card & { padding: ${rem(16)}; }
`
const Close = styled(IconButton)`
  position: absolute;
  top: ${rem(8)};
  inset-inline-end: ${rem(8)};
`

export default function SearchMapOfferSkeleton({ layout = 'row', onClose, className }: { layout?: 'row' | 'card', onClose?: () => void, className?: string }) {
  const isCard = layout === 'card'
  const intl = useIntl()
  return <Root className={isCard ? 'map-card' : className} aria-busy>
    <Image />
    <Content direction="vertical" gap={8}>
      <TextLoadingBox typography="body-large" width="85%" />
      <TextLoadingBox typography="body-small" width="65%" />
      <TextLoadingBox typography="body-medium" width="45%" />
    </Content>
    {isCard && <Close
      kind="primary"
      variant="ghost"
      shape="circle"
      onClick={onClose}
      aria-label={intl.formatMessage({
        id: 'svlT6sEDAw-vjGob5EkJ',
        defaultMessage: 'Close offer preview',
      })}
    ><LineTimesIcon />
    </Close>}
  </Root>
}
